import { angelopolisApi } from "../../api/angelopolisAPi";
import { AsesorCotizador } from "./AsesorCotizador";

export class ExclusiveContadoCotizador {
  constructor() {
    if (ExclusiveContadoCotizador.instance) {
      return ExclusiveContadoCotizador.instance;
    }
    ExclusiveContadoCotizador.instance = this;
    this.angelopolisApi = new angelopolisApi();
    this.ModalAsesor = new AsesorCotizador();
    this.menuPromoEnabled = false;
    this.loteInfo = {};
    this.enganchePromo = 10;
    this.msiPromo = 1;
    this.discount = 0;
    this.closeModalPrincipal = () => {};
    this.getUiElements();
    this.initListernesr();

    this.couta = 0;
  }

  getUiElements() {
    this.modal = document.querySelector("#modal-exclusive-contado");
    this.view = document.querySelector("#view-special-contado");
    // close modal btn
    this.closeBTn = document.querySelector("#Close-modal-special");
    // imput couto mantenimiento
    this.inputCuotaMantein = document.querySelector(
      "#input-price-cuota-special"
    );
    this.containerspecialcontado = document.querySelector(
      "#container-special-contado"
    );

    // informacion inicial
    this.outputlotenamespecial = document.querySelector(
      "#output-lote-name-special"
    );
    this.outputpricespecial = document.querySelector("#output-price-special");
    this.outputenganchespecial = document.querySelector(
      "#output-enganche-special"
    );
    this.outputmsispecial = document.querySelector("#output-msi-special");
    this.outputmensualidadspecial = document.querySelector(
      "#output-mensualidad-special"
    );
    // enable/disbale promo
    this.imgcheckpromo = document.querySelector("#img-check-promo");
    this.clickpromo = document.querySelector("#click-promo");

    this.enganchespaecial = document.querySelector("#enganche-spaecial");
    this.inputmsispecial = document.querySelector("#input-msi-special");

    // salidas en promo
    this.advicediscountspecial = document.querySelector(
      "#advice-discount-special"
    );
    this.newspecialcontraentrega = document.querySelector(
      "#new-special-contraentrega"
    );

    this.newspecialenganche = document.querySelector("#new-special-enganche");
    this.inputmsnewspecialmensualidadispecial = document.querySelector(
      "#new-special-mensualidad"
    );
    this.newspecialpricetotal = document.querySelector(
      "#new-special-price-total"
    );

    // discount uis
    this.clikmenudiscountspecial = document.querySelector(
      "#clik-menu-discount-special"
    );
    this.displaymenudiscountspecial = document.querySelector(
      "#display-menudiscount-special"
    );
    this.inputdiscountspecial = document.querySelector(
      "#input-discount-special"
    );
    this.outputamountdiscountspecial = document.querySelector(
      "#output-amount-discount-special"
    );
    this.advicenewpricespecial = document.querySelector(
      "#advice-new-price-special"
    );
    this.btnapliiscountspecial = document.querySelector(
      "#btn-apli-iscount-special"
    );
    this.advicediscountspecialdiscount = document.querySelector(
      "#advice-discount-special"
    );

    //

    // botones
    this.btnaplispecial = document.querySelector("#btn-apli-special");
    this.btncancelmodalspecial = document.querySelector(
      "#btn-cancel-modal-special"
    );
    this.btndowloadspecial = document.querySelector("#btn-dowload-special");
  }
  initListernesr() {
    this.clikmenudiscountspecial.addEventListener("click", () => {
      if (this.displaymenudiscountspecial.classList.contains("hidden")) {
        this.displaymenudiscountspecial.classList.remove("hidden");
      } else {
        this.displaymenudiscountspecial.classList.add("hidden");
      }
    });

    this.clickpromo.addEventListener("click", () => {
      if (this.menuPromoEnabled) {
        this.imgcheckpromo.src =
          "https://spacegeneral.sfo2.cdn.digitaloceanspaces.com/Angelopolis-assets-pdf/State=Empty.svg";
        this.menuPromoEnabled = false;
        this.containerspecialcontado.classList.add("hidden");
      } else {
        this.menuPromoEnabled = true;
        this.containerspecialcontado.classList.remove("hidden");
        this.imgcheckpromo.src =
          "https://spacegeneral.sfo2.cdn.digitaloceanspaces.com/Angelopolis-assets-pdf/State=Check.svg";
      }
    });

    this.enganchespaecial.addEventListener("change", () => {
      this.enganchePromo = this.enganchespaecial.value;
      console.log(this.enganchePromo);
    });
    this.inputmsispecial.addEventListener("change", (value) => {
      this.msiPromo = value.target.valueAsNumber;
      if (this.msiPromo >= 60 || this.msiPromo < 1) {
        alert("Error: Fuera de rango");
        this.inputmsispecial.value = 1;
        this.msiPromo = 1;
      }
    });

    this.inputdiscountspecial.addEventListener("change", (value) => {
      this.discount = value.target.valueAsNumber;
      if (this.discount >= 60 || this.discount < 0) {
        alert("Error: Fuera de rango");
        this.discount = 1;
        this.btnapliiscountspecial.classList.replace(
          "bg-white",
          "bg-[#8B8B8B]"
        );
        this.btnapliiscountspecial.classList.replace(
          "btn-gradient-1",
          "border-[#8B8B8B]"
        );
        this.btnapliiscountspecial.classList.replace(
          "text-black",
          "text-white"
        );
      } else {
        this.btnapliiscountspecial.classList.replace(
          "bg-[#8B8B8B]",
          "bg-white"
        );
        this.btnapliiscountspecial.classList.replace(
          "border-[#8B8B8B]",
          "btn-gradient-1"
        );
        this.btnapliiscountspecial.classList.replace(
          "text-white",
          "text-black"
        );
      }
    });

    this.btncancelmodalspecial.addEventListener("click", () => {
      console.log("asdasdasdasd");
      this.closeModal();
      this.ModalAsesor.pastoViewTwo();
    });

    this.btnapliiscountspecial.addEventListener("click", () => {
      const totalDiscount =
        this.infoPriceDefault.priceFinal * (this.discount / 100);
      const priceWhitDiscount =
        this.infoPriceDefault.priceFinal - totalDiscount;
      this.loteInfo.priceFinal = priceWhitDiscount;
      this.advicenewpricespecial.classList.replace("hidden", "flex");
      this.defaultValues();
      this.outputamountdiscountspecial.innerText = this.convertToFormat(
        priceWhitDiscount
      );
      this.advicediscountspecialdiscount.classList.replace("hidden", "flex");
    });

    this.btnaplispecial.addEventListener("click", () => {
      this.advicediscountspecial.classList.replace("hidden", "flex");
      const enganchePromo =
        this.loteInfo.priceFinal * (this.enganchePromo / 100);
      const contraentregaPromo = this.loteInfo.priceFinal * 0.2;
      const amountToMSI =
        this.loteInfo.priceFinal - enganchePromo - contraentregaPromo;
      const mensualidadPromo =
        this.msiPromo === 0 ? 0 : amountToMSI / this.msiPromo;

      // pintar en ui
      this.newspecialenganche.innerText = this.convertToFormat(enganchePromo);
      this.newspecialcontraentrega.innerText = this.convertToFormat(
        contraentregaPromo
      );
      this.inputmsnewspecialmensualidadispecial.innerText = this.convertToFormat(
        mensualidadPromo
      );
      this.newspecialpricetotal.innerText = this.convertToFormat(
        this.loteInfo.priceFinal
      );

      this.loteInfo.plazo = this.msiPromo;
      this.loteInfo.mensualidadValue = 100 - 20 - this.enganchePromo;
      this.loteInfo.mensualidad = mensualidadPromo;
      this.loteInfo.engancheValue = this.enganchePromo / 100;
      this.loteInfo.engancheAmount = enganchePromo;
      this.loteInfo.percentageContraEntrega = 0.2;
      this.loteInfo.mountContraEntrega = contraentregaPromo;
    });

    this.inputCuotaMantein.addEventListener("change", (value) => {
      // console.log(value.target.valueAsNumber);
      this.couta = value.target.valueAsNumber;
      if (value.target.valueAsNumber >= 1) {
        this.btndowloadspecial.disabled = false;
        this.btndowloadspecial.classList.replace(
          "bg-[#8B8B8B]",
          "bg-[#ED2F37]"
        );
        this.btndowloadspecial.classList.replace(
          "border-[#8B8B8B]",
          "border-[#ED2F37]"
        );
      } else {
        this.btndowloadspecial.disabled = true;
        this.btndowloadspecial.classList.replace(
          "bg-[#ED2F37]",
          "bg-[#8B8B8B]"
        );
        this.btndowloadspecial.classList.replace(
          "border-[#ED2F37]",
          "border-[#8B8B8B]"
        );
      }
    });
    this.closeBTn.addEventListener("click", () => {
      this.closeModal();
    });

    this.btndowloadspecial.addEventListener("click", () => {
      this.onGeneratePdf();
    });
  }

  setDefaultValues() {
    this.outputlotenamespecial.innerText = this.loteInfo.loteinfo.NombreBusqueda;
    this.outputpricespecial.innerText = this.convertToFormat(
      this.loteInfo.priceFinal
    );
    this.outputenganchespecial.innerText = this.convertToFormat(
      this.loteInfo.engancheAmount
    );
    this.outputmsispecial.innerText = `${this.loteInfo.plazo} MSI`;
    this.outputmensualidadspecial.innerText = this.convertToFormat(
      this.loteInfo.mensualidad
    );
  }

  enableModal(payloadLote, payloadSeller, closeModalPrincipal) {
    this.loteInfo = payloadLote;
    this.infoPriceDefault = { ...this.loteInfo };
    this.infoUsers = payloadSeller;
    this.closeModalPrincipal = closeModalPrincipal;
    this.modal.classList.replace("hidden", "flex");
    this.setDefaultValues();
  }

  defaultValues() {
    this.enganchespaecial.value = 10;
    this.inputmsispecial.value = 1;
    
    this.enganchePromo = 10;
    this.msiPromo = 1;
    this.newspecialenganche.innerText = this.convertToFormat(0);
    this.newspecialcontraentrega.innerText = this.convertToFormat(0);
    this.inputmsnewspecialmensualidadispecial.innerText = this.convertToFormat(
      0
    );
    this.newspecialpricetotal.innerText = this.convertToFormat(0);
    this.loteInfo.plazo = this.infoPriceDefault.plazo;
    this.loteInfo.mensualidadValue = this.infoPriceDefault.mensualidadValue;
    this.loteInfo.mensualidad = this.infoPriceDefault.mensualidad;
    this.loteInfo.engancheValue = this.infoPriceDefault.engancheValue;
    this.loteInfo.engancheAmount = this.infoPriceDefault.engancheAmount;
    this.loteInfo.percentageContraEntrega = this.infoPriceDefault.percentageContraEntrega;
    this.loteInfo.mountContraEntrega = this.infoPriceDefault.mountContraEntrega;
  }
  closeModal() {
    this.modal.classList.replace("flex", "hidden");
    this.advicediscountspecial.classList.replace("flex", "hidden");
    this.imgcheckpromo.src =
      "https://spacegeneral.sfo2.cdn.digitaloceanspaces.com/Angelopolis-assets-pdf/State=Empty.svg";
    this.menuPromoEnabled = false;
    this.containerspecialcontado.classList.add("hidden");
    this.couta = 0;
    this.defaultValues();
  }

  async onGeneratePdf() {
    console.clear();

    const formatedApiBody = {
      date: new Date(),
      type: this.loteInfo.type,
      discountAplicated: this.discount,
      asesorName: this.infoUsers.name,
      asesorPhone: this.infoUsers.phone,
      asesorEmail: this.infoUsers.email,
      interestedName: this.infoUsers.clientName,
      interestedPhone: this.infoUsers.clientPhone,
      interestedEmail: this.infoUsers.clientEmail,
      planeImg: this.loteInfo.loteinfo.image,
      clusterName: this.loteInfo.loteinfo.CodigoProducto.split(" ")[0],
      loteDirection: this.loteInfo.loteinfo.NombreBusqueda,
      dimensionsLote: this.loteInfo.loteinfo.meters,
      priceMeter: this.convertToFormat(this.loteInfo.priceMeter),
      priceFinancial: this.convertToFormat(this.loteInfo.priceFinancial),
      engancheValue: this.loteInfo.engancheValue,
      engancheAmount: this.convertToFormat(this.loteInfo.engancheAmount),
      plazo: this.loteInfo.plazo,
      mensualidad: this.convertToFormat(this.loteInfo.mensualidad),
      priceFinal: this.convertToFormat(this.loteInfo.priceFinal),
      mensualidadValue: this.loteInfo.mensualidadValue,
      maintenanceMount: this.convertToFormat(this.couta),
      percentageContraEntrega: this.loteInfo.percentageContraEntrega,
      mountContraEntrega: this.convertToFormat(
        this.loteInfo.mountContraEntrega
      ),
      notDicountPlazo: this.loteInfo.notDicountPlazo,
      notDiscountpriceMeter: this.convertToFormat(
        this.loteInfo.notDiscountpriceMeter
      ),
      notDiscountenganche: this.convertToFormat(
        this.loteInfo.notDiscountenganche
      ),
      notDiscountContraenetrega: this.convertToFormat(
        this.loteInfo.notDiscountContraenetrega
      ),
      notDiscountmenusalidad: this.convertToFormat(
        this.loteInfo.notDiscountmenusalidad
      ),
      notDiscountpriceFinancial: this.convertToFormat(
        this.loteInfo.notDiscountpriceFinancial
      ),
    };
    console.log(formatedApiBody);
    const result = await this.angelopolisApi.onGeneratePDfApi(formatedApiBody);
    if (result.payload.ok) {
      window.open(result.payload.path, "_blank");
      // this.closeModal();
    }
  }

  convertToFormat(number) {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
}
